// removed by extract-text-webpack-plugin
module.exports = {"ProfileDetailsPreview":"ProfileDetailsPreview---Vac4Z","SidebarContainer":"SidebarContainer---1QJYN","Sidebar":"Sidebar---1IXtw","SidebarPreview":"SidebarPreview---1U08_","ArrowText":"ArrowText---1A9VX","PreviewSlackChat":"PreviewSlackChat---1-FpC","PreviewSlackLiveChat":"PreviewSlackLiveChat---2qJce","PreviewLaptop":"PreviewLaptop---2bNvD"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/SlackInstall/Preview/style.styl
// module id = bwU9
// module chunks = 89